import TripMatchSalesCard from './trip-match-sales-card';

export default TripMatchSalesCard;
